import { StyleSheet } from "@react-pdf/renderer";
import { blue, white } from "./PDFColors";

export const styles = StyleSheet.create({
  backgroundBlue: {
    height: "100%",
    width: "100%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "10pt",
  },

  rolesResponsibilitiesContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
  },

  rolesResponsibilitiesBox: {
    width: "28%",
    height: "43%",
    borderStyle: "solid",
    borderColor: blue,
    borderWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    margin: "15px",
  },
  foundersBox: {
    height: "20%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: blue,
  },
  textFounders: { color: white },
  titleBox: {
    height: "17%",
    width: "100%",
    borderBottomStyle: "solid",
    borderBottomColor: blue,
    borderBottomWidth: "1pt",
    justifyContent: "center",
    alignItems: "center",
  },
  textRR: { fontSize: "13px" },
  tagBox: {
    width: "100%",
    height: "100%",
    textAlign: "justify",
    padding: "4px",
  },
  textTag: { fontSize: "12px", margin: "3px", textAlign: "justify" },
  text: { textAlign: "left", fontSize: "11px", marginTop: "2px" },
});
